import ReactDOM from "react-dom";

import { AppLoader } from "AppLoader";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";

var firebaseConfig = {
    apiKey: "AIzaSyBwZkXDOPQk759lH2Bqpoe7_xCYJUQIoxA",
    authDomain: "quilt-farm.firebaseapp.com",
    projectId: "quilt-farm",
    storageBucket: "quilt-farm.appspot.com",
    messagingSenderId: "230376437612",
    appId: "1:230376437612:web:989ec83527074c7e826549",
    measurementId: "G-GLMMFPGS9K"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

// can't use because of bootstrap
// <React.StrictMode>
// </React.StrictMode>
ReactDOM.render(
    <AppLoader />,
    document.getElementById("root")
);